import { stringify } from 'qs';
import request from '@/utils/request';

export async function queryApplicationList(params) {
  return request(`/system-applications?${stringify(params)}`);
}

export async function queryApplicationDetail(id) {
  return request(`/system-applications/${id}`);
}

export async function createApplication(params) {
  return request('/system-applications', {
    method: 'POST',
    data: params,
  });
}

export async function updateApplication(params) {
  const { id, ...rest } = params;
  return request(`/system-applications/${id}`, {
    method: 'PUT',
    data: rest,
  });
}
